// Angular imports
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// Model imports
import { BoardApprovalActionParameterDto } from '../../_models/board-approval-action-parameter-dto';
import { BoardApprovalActionsResultDto } from '../../_models/board-approval-actions-result-dto';

// Component imports
import { DxFormComponent } from 'devextreme-angular';

@Component({
    selector: 'app-board-approval-note-editor',
    templateUrl: './board-approval-note-editor.component.html',
    styleUrls: ['./board-approval-note-editor.component.scss']
})
export class BoardApprovalNoteEditorComponent {
    @ViewChild('notesEditorForm', { static: false }) notesEditorForm: DxFormComponent;

    @Input() visible: boolean;
    @Input() popupTitle: string;
    @Input() actionResult: BoardApprovalActionsResultDto;
    @Input() actionParameter: BoardApprovalActionParameterDto;
    @Output() onClose = new EventEmitter<any>();

    iconCheck = IconConstants.CHECK;
    iconCancel = IconConstants.CROSS;

    onPopupHidden(): void {
        this.visible = false;
        this.onClose.emit(null);
    }

    onCancelClick(): void {
        this.onPopupHidden();
    }

    onOkClick(): void {
        if (Utils.isTrue(this.notesEditorForm.instance.validate().isValid)) {
            this.visible = false;
            this.onClose.emit(this.actionParameter);
        }
    }
}
